// @ts-nocheck
import { Button, Modal } from "antd";
import { useEffect, useState, useImperativeHandle } from "preact/hooks";
import { forwardRef } from "react";
import { h } from "preact";
import { useForm } from "react-hook-form";
import BaseForm from "../../../../components/form";
import { useMessage } from "../../../../hooks/useMessage";
import { FORM_END_JOB_REPAIR } from "../../constants/forms";
import { IPropsModal } from "../../interface/modal";
import { ContainerConfirmGetJob } from "../../styled";
import { Text } from "../../../../components/text";
import { useSelector } from "react-redux";
import { POST, PRODUCT_CLOSE } from "../../../../services";
import { useGetDeliveryOptions } from "../../hook/useGetDeliveryOptions";

const defaultValues = {
  customerName: "",
  saleCode: "",
  userCreate: "",
  claimId: "",
  createDate: "",
  customerCode: "",
  description: "",
  deviceId: "",
  deviceLotId: "",
  versionMachine: "",
  maintainId: "",
  maintainStatus: "",
  maintainType: "",
  remaining: "",
  team: "",
  zone: "",
  main_confirm_worker: "",
  main_confirm_start_date: "",
  main_endjob_name_tech: "",
  main_endjob_tech_start_date: "",
  main_endjob_tech_start_repair_date: "",
  main_endjob_tech_end_repair_date: "",
  main_endjob_remark: "",
};

interface Props {
  onCallbackEdit: () => void;
}

const EndJob = (props: Props, ref) => {
  const userState: any = useSelector((state: IAuthState) => state.auth.user);
  const { onCallbackEdit } = props;
  const { openMessage } = useMessage();
  const [visible, setVisible] = useState(false);
  // const [mainId, setMaineId] = useState("");
  const [loading, setLoading] = useState(false);
  const { control, setValue, getValues, reset, handleSubmit, watch } = useForm({
    defaultValues,
  });

  const { deliveryOptions } = useGetDeliveryOptions();

  const { deviceId, maintainId } = watch();

  useImperativeHandle(ref, () => ({
    async openModal(e: any) {
      try {
        for (const key in e) {
          const element = e[key];
          if (key in defaultValues) {
            setValue(key as keyof typeof defaultValues, element);
          }
        }
        setValue("userId", userState.fullName);
        setVisible(true);
      } catch (error) {
        console.log(error);
      }
    },
  }));

  useEffect(() => {
    !visible && reset();
  }, [visible]);

  const onConfirm = async (values) => {
    try {
      setLoading(true);
      const { main_endjob_remark, main_endjob_tracking, main_endjob_delivery } =
        values;
      const res = await POST(PRODUCT_CLOSE, {
        maintainId,
        remark: main_endjob_remark,
        deliveryChannel: main_endjob_delivery,
        trackingNo: main_endjob_tracking,
      });
      if (!res.success) {
        return;
      }
      setLoading(false);
      openMessage("success", res.message);
      onCallbackEdit && onCallbackEdit(getValues());
      setVisible(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
      openMessage("error", (error as Error).message);
    }
  };

  return (
    <Modal
      centered
      width={650}
      title={
        (
          <Text size={"L"} text={`ปิดจบงาน #${maintainId}`} bold />
        ) as React.ReactNode
      }
      transitionName={""}
      visible={visible}
      okText={"ปิดจบงาน"}
      cancelText={"ยกเลิก"}
      confirmLoading={loading}
      onOk={handleSubmit(onConfirm)}
      onCancel={() => setVisible(false)}
      destroyOnClose={() => setVisible(false)}
    >
      <ContainerConfirmGetJob>
        <Text size={"S"} text={`หมายเลขเครืองตัด: ${deviceId}`} />
      </ContainerConfirmGetJob>
      <BaseForm
        control={control}
        forms={FORM_END_JOB_REPAIR({ deliveryOptions })}
        setValue={setValue}
        getValues={getValues}
      />
    </Modal>
  );
};

export const ModalEndJob = forwardRef<any, IPropsModal>(EndJob);
